import React from 'react';
import { useParams } from 'react-router-dom';
import B2BOrderForm from '../components/B2BOrders/B2BOrderForm';
import B2BOrdersTable from '../components/B2BOrders/B2BOrdersTable';
import AdminRouteGate from '../components/feedback/AdminRouteGate';

/**
 * B2B orders are admin-only.
 *
 * Every endpoint behind these screens is IsAdmin-gated, so a vendor who reached
 * one would get the whole UI and a 403 on submit. Bounce them to Orders instead
 * — the same guard TerminalManualOrder and TerminalLabels use.
 *
 * One guard serves all three screens rather than three near-identical
 * wrappers; the exported components below are what the router mounts.
 */
// The shared gate distinguishes "you are not an admin", which redirects, from
// "we could not check", which says so and offers a retry — rather than silently
// sending a real admin away when the role lookup fails mid-deploy.
function AdminOnly({ children }) {
  return <AdminRouteGate>{children}</AdminRouteGate>;
}

export function TerminalB2BOrders() {
  return (
    <AdminOnly>
      <B2BOrdersTable />
    </AdminOnly>
  );
}

export function TerminalB2BOrderNew() {
  return (
    <AdminOnly>
      <B2BOrderForm />
    </AdminOnly>
  );
}

export function TerminalB2BOrderEdit() {
  const { orderId } = useParams();
  return (
    <AdminOnly>
      <B2BOrderForm orderId={orderId} />
    </AdminOnly>
  );
}

export default TerminalB2BOrders;
